<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

   <v-card style="height: auto;width: 100vw;margin-right: 5px" >





   </v-card>


</template>

<script>
    export default {
        name: "AppArticle",
        data() {
            return {
                clinicTheme: '',
                regPage:'',
            }
        },
        created(){
           this.axios_getSysTheme();//取得畫面樣式
        },
        methods:{
            axios_getSysTheme (){ //查詢樣式theme設定檔
                let url = '';
                this.clinicTheme = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/BASEINFO/THEME";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.clinicTheme = response.data.resultSet[0].value3;
                        this.axios_getSysRegPage();
                    }else{
                        this.clinicTheme = 'ClinicA';
                        this.axios_getSysRegPage();
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.clinicTheme = 'ClinicA';
                    } catch(err) {
                        this.clinicTheme = 'ClinicA';
                    }
                    this.axios_getSysRegPage();

                });

            },
            axios_getSysRegPage (){ //查詢 REGPAGE 設定檔
                let url = '';
                this.regPage = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/BASEINFO/REGPAGE";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.regPage = response.data.resultSet[0].value1;
                        if(this.regPage!==null&&this.regPage.toUpperCase().indexOf('INDEX')>-1){
                            this.$router.push({name: this.regPage});
                        }else if(this.regPage==null) {
                            if(this.$route.query.zone!==undefined&&this.$route.query.zone!==''){ //110/09/14 加入院區判斷 如果有傳入zone
                                this.$router.push({name: this.clinicTheme,query:{zone:this.$route.query.zone}});
                            }else {
                                this.$router.push({name: this.clinicTheme});
                            }
                        }else {
                            if(this.$route.query.zone!==undefined&&this.$route.query.zone!==''){ //110/09/14 加入院區判斷 如果有傳入zone
                                this.$router.push({name: this.clinicTheme, params:{divCode:this.regPage},query:{zone:this.$route.query.zone}});
                            }else {
                                this.$router.push({name: this.clinicTheme, params:{divCode:this.regPage}});
                            }
                        }
                    }else{
                        this.regPage = '';
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.regPage = '';
                    } catch(err) {
                        this.regPage = '';
                    }

                });


            },
        }
    }
</script>

<style scoped>



</style>